import { ADD_CURRENT_COUNT, ADD_STUDENT, ADD_STUDENT_COUNT, INIT_REGISTRATION, CLEAR, ADD_CODE, PAY_DETAILS } from "../types";


const formReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case INIT_REGISTRATION:
            return {
                ...state,
                regDetails: payload,
            }
        case ADD_STUDENT:
            return {
                ...state,
                participants: [...state.participants, payload]
            }
        case ADD_STUDENT_COUNT:
            return {
                ...state,
                studentCountValue: payload,
                currentStudentCount: 0
            }
        case ADD_CURRENT_COUNT:
            return {
                ...state,
                currentStudentCount: payload
            }
        case ADD_CODE:
            return {
                ...state,
                alert: payload
            }
        case PAY_DETAILS:
            return {
                ...state,
                payObj: payload
            }
        case CLEAR:
            return {
                regDetails: null,
                participants: [],
                studentCountValue: 0,
                currentStudentCount: 0,
                alert: '',
                payObj: {
                    amount: '',
                    email: '',
                    phone: '',
                    msg: '',
                    schoolName: '',
                    participants: '',
                    name: '',
                },
            }
        default:
            return state;
    }
}

export default formReducer;